import React, { useEffect, useState } from 'react';
import { _axios as axios, cancelToken, customFetch } from '../../utils/auth';
import SearchBarComponent from '../../components/SearchBar/SearchBar';
import SearchList from '../../components/SearchList/SearchList';
import { url } from '../../utils';
import './SearchDemo.css';
import FormControl from '@mui/material/FormControl';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

interface List {
  label: string;
  link: string;
}

interface ListSearchDistanceType {
  onKeyword: List;
  project?: Array<List>;
  recommended?: Array<List>;
  mall?: Array<List>;
  university?: Array<List>;
  hospital?: Array<List>;
  popular_area?: Array<List>;
  road?: Array<List>;
  airport?: Array<List>;
  train?: Array<List>;
  park?: Array<List>;
  location_type?: Array<List>;
}

interface ListSearchNameType {
  list_actions: Array<List>;
  phrase_match?: Array<List>;
}

const useDebounceValue = (value: string) => {
  const [deBouncedValue, setDeBounceValue] = useState(value);
  useEffect(() => {
    const timeout = setTimeout(() => {
      setDeBounceValue(value);
    }, 300);

    return () => clearTimeout(timeout);
  }, [value]);

  return deBouncedValue;
};

const SearchBar = () => {
  const [keyword, setKeyword] = useState<string>('');
  const [language, setLanguage] = useState<'th' | 'en' | 'cn'>('th');
  const [listSearchDistance, setlistSearchDistance] = useState<ListSearchDistanceType>();
  const [listSearchName, setlistSearchName] = useState<ListSearchNameType>();
  // const [isValidating, setIsValidating] = useState<Boolean>(false);
  const finalKeyword = useDebounceValue(keyword);

  // const { data, error, isValidating } = useSWR(`${url}/v1/search`)

  useEffect(() => {
    getListSearchName();
    getListSearchDistance();
  }, [finalKeyword]);

  const getListSearchDistance = async () => {
    // setIsValidating(true);
    const response = await axios.post(
      `${url}/v1/search/distance`,
      {
        keyword: keyword,
      },
      {
        headers: {
          'Accept-Language': language,
        },
      },
    );
    setlistSearchDistance(response.data.data);
  };

  const getListSearchName = async () => {
    const response = await axios.post(
      `${url}/v1/search/name`,
      {
        keyword: keyword,
      },
      {
        headers: {
          'Accept-Language': language,
        },
      },
    );
    setlistSearchName(response.data.data);
  };

  const handleChangeLanguage = (event: SelectChangeEvent) => {
    const language = event.target.value as 'th' | 'en' | 'cn';
    setLanguage(language);
  };

  const insertHistory = async (value: string) => {
    await axios.post(
      `${url}/v1/history`,
      {
        url: value,
      },
      {
        headers: {
          'Accept-Language': 'th',
        },
      },
    );
  };

  return (
    <div className="relative">
      <Box
        sx={{
          margin: '1rem 0',
        }}>
        <FormControl>
          <InputLabel id="demo-simple-select-label">language</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={language}
            label={'language'}
            onChange={handleChangeLanguage}>
            <MenuItem value={'th'}>th</MenuItem>
            <MenuItem value={'en'}>en</MenuItem>
            <MenuItem value={'cn'}>cn</MenuItem>
          </Select>
        </FormControl>
      </Box>
      <SearchBarComponent
        finalKeyword={finalKeyword}
        keyword={keyword}
        setKeyword={setKeyword}
        listSearchDistance={listSearchDistance}
        insertHistory={insertHistory}
      />
      {/* <div
        className={`border-2 ${
          finalKeyword ? 'rounded-t-2xl border-b-0' : 'rounded-full'
        } flex flex-col `}
      >
        <div className="flex items-center gap-x-4 px-3 py-1.5 text-inherit border-inherit">
          <SearchIcon color="disabled" />
          <input
            id="search_keyword"
            className="w-full border-none focus:outline-none text-lg"
            type="text"
            value={keyword}
            onChange={(e) => {
              setKeyword(e.target.value);
            }}
            onKeyPress={handleKeydown}
          />
          {keyword && (
            <IconButton
              color="inherit"
              aria-label="upload picture"
              component="span"
              onClick={handleDeleteKeyword}
            >
              <CloseIcon />
            </IconButton>
          )}
        </div>
      </div> */}
      <div className={`flex flex-col gap-1 ${finalKeyword ? 'border-2 rounded-b-2xl absolute w-full bg-white' : ''}`}>
        {/* {finalKeyword && Boolean(listSearchDistance?.onKeyword?.length) && (
          <div className="px-12 text-xs text-gray-600">โครงการ</div>
        )} */}

        {/* {keyword && (
            <div className="bg-gray-200 -mx-12 px-12 py-1.5">{keyword}</div>
          )} */}
        {finalKeyword && Boolean(listSearchDistance?.recommended?.length) && (
          <div className="px-12 text-xs text-gray-600">แนะนำ</div>
        )}
        {finalKeyword && Boolean(listSearchDistance?.onKeyword) && (
          <SearchList
            label={listSearchDistance?.onKeyword.label}
            link={listSearchDistance?.onKeyword.link}
            onClick={insertHistory}
            setKeyword={setKeyword}
          />
        )}
        <div className="px-12 text-xs text-gray-600">pharse match</div>
        {finalKeyword &&
          Boolean(listSearchName?.phrase_match?.length) &&
          listSearchName?.phrase_match?.map((e, index) => {
            return (
              <SearchList key={index} label={e.label} link={e.link} onClick={insertHistory} setKeyword={setKeyword} />
            );
          })}
        <div className="px-12 text-xs text-gray-600">distance match</div>
        {finalKeyword &&
          Boolean(listSearchDistance?.recommended?.length) &&
          listSearchDistance?.recommended?.map((e, index) => {
            return (
              <SearchList key={index} label={e.label} link={e.link} onClick={insertHistory} setKeyword={setKeyword} />
            );
          })}
        {finalKeyword &&
          Boolean(listSearchDistance?.location_type?.length) &&
          listSearchDistance?.location_type?.map((e, index) => {
            return (
              <SearchList key={index} label={e.label} link={e.link} onClick={insertHistory} setKeyword={setKeyword} />
            );
          })}
        {/* {finalKeyword &&
          Boolean(listSearchDistance?.location_type?.length) &&
          listSearchDistance?.location_type?.map((e, index) => {
            return <SearchList key={index} label={e.label} link={e.link} />;
          })}
        {finalKeyword && Boolean(listSearchDistance?.project?.length) && (
          <div className="px-12 text-xs text-gray-600">โครงการ</div>
        )} */}
        {finalKeyword && Boolean(listSearchDistance?.project?.length) && (
          <div className="px-12 text-xs text-gray-600">โครงการ</div>
        )}
        {finalKeyword &&
          Boolean(listSearchDistance?.project?.length) &&
          listSearchDistance?.project?.map((e, index) => {
            return (
              <SearchList key={index} label={e.label} link={e.link} onClick={insertHistory} setKeyword={setKeyword} />
            );
          })}
        {finalKeyword && Boolean(listSearchDistance?.train?.length) && (
          <div className="px-12 text-xs text-gray-600">ใกล้ รถไฟฟ้า</div>
        )}
        {finalKeyword &&
          Boolean(listSearchDistance?.train?.length) &&
          listSearchDistance?.train?.map((e, index) => {
            return (
              <SearchList key={index} label={e.label} link={e.link} onClick={insertHistory} setKeyword={setKeyword} />
            );
          })}
        {finalKeyword && Boolean(listSearchDistance?.road?.length) && (
          <div className="px-12 text-xs text-gray-600">ใกล้ ถนน</div>
        )}
        {finalKeyword &&
          Boolean(listSearchDistance?.road?.length) &&
          listSearchDistance?.road?.map((e, index) => {
            return (
              <SearchList key={index} label={e.label} link={e.link} onClick={insertHistory} setKeyword={setKeyword} />
            );
          })}
        {finalKeyword && Boolean(listSearchDistance?.mall?.length) && (
          <div className="px-12 text-xs text-gray-600">ใกล้ ห้างสรรพสินค้า</div>
        )}
        {finalKeyword &&
          Boolean(listSearchDistance?.mall?.length) &&
          listSearchDistance?.mall?.map((e, index) => {
            return (
              <SearchList key={index} label={e.label} link={e.link} onClick={insertHistory} setKeyword={setKeyword} />
            );
          })}
        {finalKeyword && Boolean(listSearchDistance?.university?.length) && (
          <div className="px-12 text-xs text-gray-600">ใกล้ มหาวิทยาลัย</div>
        )}
        {finalKeyword &&
          Boolean(listSearchDistance?.university?.length) &&
          listSearchDistance?.university?.map((e, index) => {
            return (
              <SearchList key={index} label={e.label} link={e.link} onClick={insertHistory} setKeyword={setKeyword} />
            );
          })}

        {finalKeyword && Boolean(listSearchDistance?.hospital?.length) && (
          <div className="px-12 text-xs text-gray-600">ใกล้ โรงพยาบาล</div>
        )}
        {finalKeyword &&
          Boolean(listSearchDistance?.hospital?.length) &&
          listSearchDistance?.hospital?.map((e, index) => {
            return (
              <SearchList key={index} label={e.label} link={e.link} onClick={insertHistory} setKeyword={setKeyword} />
            );
          })}
        {finalKeyword && Boolean(listSearchDistance?.park?.length) && (
          <div className="px-12 text-xs text-gray-600">ใกล้ สวนสาธารณะ</div>
        )}
        {finalKeyword &&
          Boolean(listSearchDistance?.park?.length) &&
          listSearchDistance?.park?.map((e, index) => {
            return (
              <SearchList key={index} label={e.label} link={e.link} onClick={insertHistory} setKeyword={setKeyword} />
            );
          })}
        {finalKeyword && Boolean(listSearchDistance?.airport?.length) && (
          <div className="px-12 text-xs text-gray-600">ใกล้ สนามบิน</div>
        )}
        {finalKeyword &&
          Boolean(listSearchDistance?.airport?.length) &&
          listSearchDistance?.airport?.map((e, index) => {
            return (
              <SearchList key={index} label={e.label} link={e.link} onClick={insertHistory} setKeyword={setKeyword} />
            );
          })}
        {finalKeyword && Boolean(listSearchDistance?.popular_area?.length) && (
          <div className="px-12 text-xs text-gray-600">สถานที่ยอดนิยม</div>
        )}
        {finalKeyword &&
          Boolean(listSearchDistance?.popular_area?.length) &&
          listSearchDistance?.popular_area?.map((e, index) => {
            return (
              <SearchList key={index} label={e.label} link={e.link} onClick={insertHistory} setKeyword={setKeyword} />
            );
          })}
      </div>
    </div>
  );
};

export default SearchBar;
